<template>
  <div>
    <!-- 用户修改信息弹窗 -->
    <dialog-modal
      :showDialogModal="showEditUserMsgModal"
      :showCancelBtn="false"
      @show="handleEditUserMsg"
      v-bind="dialogConfig"
      class="mobile-user-info"
    >
      <template #content>
        <div class="user-ed-content">
          <h3>{{ i18n.t('mbs-user-edit') }}</h3>
          <i18n-t keypath="mbs-edit-desc" tag="p">
            <a
              class="email"
              @click="
                handleCancel();
                $router.push({
                  path: '/account/contact',
                });
              "
            >
              {{ i18n.t('mbs-select-Contact') }}
            </a>
          </i18n-t>
          <div class="user-ed-form">
            <div class="form">
              <!-- 表单组件部分 -->
              <!-- <restpwd-form
                v-bind="userEditFormConfig"
                :formValue="userEditFormValue"
                :errMessage="errMessage"
                @changeFormValue="formValueChange"
              ></restpwd-form> -->
              <UserEditForm
                :initialValues="userEditFormValue"
                :errMessage="errMessage"
                @changeFormValue="formValueChange"
              />
            </div>
            <!--          // 新需求，不再上传用户头像-->
            <!--          <div class="upload">-->
            <!--            <upload :uploadImgs="uploadImgs" @uploadFile="handleUploadFile"></upload>-->
            <!--          </div>-->
          </div>
        </div>
      </template>
      <template #footer>
        <div class="user-ed-btn">
          <button @click="handleCancel">{{ i18n.t('btn-cancel') }}</button>
          <button @click="handleConfirm">{{ i18n.t('btn-save') }}</button>
        </div>
      </template>
    </dialog-modal>
    <dialog-modal
      :showDialogModal="showCaptcha"
      :showCancelBtn="true"
      @show="handleCaptchaShow"
      v-bind="dialogConfig"
      class="mobile-user-info"
    >
      <template #content>
        <div style="height: 40px"></div>
        <Captcha
          @handleResend="handleResend"
          @handleDone="handleDone"
          @handleFinish="handleFinish"
          :errMsg="errCaptchaMsg"
          :bottomline="false"
        >
          <template #title>
            <img src="~img/icon-lock-black.svg" alt="lock" />
            <span>{{ i18n.t('code-auth-title') }}</span>
          </template>
          <template #subtitle>{{ i18n.t('mfa-code-subtitle') }}</template>
          <template #desc>{{ i18n.t('code-auth-desc1') }}</template>
          <template #info>{{ captchaPhone }}</template>
          <template #other>{{ i18n.t('mfa-code-info') }}</template>
        </Captcha>
      </template>
    </dialog-modal>
  </div>
</template>

<script>
  import DialogModal from '@/components/BaseUi/DialogModal';
  // import restpwdForm from '@/components/BaseUi/Form/src/index.vue';
  import { userEditFormConfig, dialogConfig } from './edit.config';
  import store from '@/store';
  import Upload from '@/components/BaseUi/Upload';
  import verify from '@/utils/verify';
  import i18n from '@/i18n';
  import { mapState } from 'vuex';
  import { encryptAES, getFirst4andLast2Num } from '@/utils';
  import Captcha from '@/views/Login/Captcha.vue';
  import UserEditForm from '@/components/UserEditForm/index.vue';

  // 此文件用于移动端修改用户信息的页面（/profile）以及PC端membership页面的profile组件
  export default {
    name: 'index',
    components: {
      DialogModal,
      // restpwdForm,
      Upload,
      Captcha,
      UserEditForm,
    },

    data() {
      return {
        emailAddress: '',
        i18n,
        userEditFormConfig,
        userEditFormValue: {},
        errMessage: [],
        uploadImgs: '',
        showEditUserMsgModal: false,
        userUploadFile: {},
        formData: {},
        mfaDetail: {},
        showCaptcha: false,
        errCaptchaMsg: '',
      };
    },
    props: {
      // 默认为移动端样式，dialog不需要居中
      dialogConfig: {
        default: () => {
          return dialogConfig;
        },
        type: Object,
      },
      // PC 端判断组件是否展示
      showDialog: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      captchaPhone() {
        const { exphone, phone } = this.userEditFormValue;
        const phEx = `+${exphone}`;
        const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
        return `${phEx} ${getFirst4andLast2Num(newPhone)}`;
      },
      ...mapState(['userInfo']),
    },
    mounted() {
      this.handleEditUserMsg();
      if (this.$route.path === '/profile') {
        this.getMFAStatus();
      }
      // this.getDpid();
    },
    methods: {
      async getDpid() {
        const dragoncard = await this.getDragonCard();
        this.emailAddress = `mailto:ca.support@dragonpassuk.com?subject=Enquiry or Feedback ${dragoncard.card.dragoncode.replace(
          /(\d{4})/g,
          '$1 ',
        )}`;
        console.log('emailAddress', this.emailAddress);
      },
      getDragonCard() {
        const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
        const dragonCardData = {
          lang: this.$i18n.locale,
          device: 'web',
          version: '1.0.0',
          userId: this.userInfo.userId,
          sessionId: this.userInfo.sessionId,
          deviceName,
        };

        return this.$http.login.getDragonCard(dragonCardData);
      },
      // goToContact() {
      //   this.$emit('updateFatherGoToContact');
      //   if (this.showDialog) {
      //     this.showEditUserMsgModal = true;
      //   }
      //   this.errMessage = [];
      //   this.uploadImgs = '';
      //   this.formData = {};
      //   this.showEditUserMsgModal = false;
      //   router.push({ name: 'Contact' });
      // },
      handleEditUserMsg(data = true) {
        const { firstName, lastName, email, phoneEx: exphone, phone, head } = this.userInfo;

        this.uploadImgs = head;

        const phEx = `+${exphone}`;
        const newPhone =
          phone.indexOf(phEx) !== -1 ? { phone: phone.slice(phEx.length) } : { phone };

        this.showEditUserMsgModal = Boolean(data);
        this.userEditFormValue = {
          fname: firstName,
          lname: lastName,
          email,
          exphone,
          phone,
          ...newPhone,
        };
      },

      handleCancel() {
        // todo 优化写法
        this.userEditFormConfig.formItems.forEach(item => {
          item?.children?.forEach(_ => {
            _.on = false;
          });
        });
        this.userEditFormConfig.formItems.forEach(item => {
          if (item.on !== undefined) item.on = false;
        });
        this.userEditFormConfig.formItems.forEach(item => {
          if (item.icon !== undefined) item.icon = 'off';
        });
        this.$emit('updateFather');
        if (this.showDialog) {
          this.showEditUserMsgModal = true;
        }
        this.errMessage = [];
        this.uploadImgs = '';
        this.formData = {};
        // 将showEditUserMsgModal放到微任务中，等上面的处理完后再执行
        this.$nextTick(() => {
          this.showEditUserMsgModal = false;
        });
      },
      showMessageBox(data) {
        if (data === 'success') {
          this.$messageModal.show({
            i18nNeed: true,
            image: true,
            title: 'msg-success-status',
            desc: 'profile-success',
            confirmBtn: 'btn-ok',
            justHide: true,
          });
        }
      },
      handleSave() {
        this.userEditFormConfig.formItems.forEach(item => {
          item?.children?.forEach(_ => {
            _.on = false;
          });
        });
        this.userEditFormConfig.formItems.forEach(item => {
          if (item.on !== undefined) item.on = false;
        });
        this.userEditFormConfig.formItems.forEach(item => {
          if (item.icon !== undefined) item.icon = 'off';
        });
        const { mobileNumber } = this.userEditFormValue;
        verify({ mobileNumber }).then(errMsg => {
          if (errMsg.pass) {
            const { exphone, phone } = this.userEditFormValue;
            const { userId, sessionId } = this.userInfo;
            // const { sessionId } = this;
            this.formData = new FormData();
            // 新需求，不再上传用户头像
            // this.formData.append('imgFile', this.userUploadFile[0] || '');
            this.formData.append('userId', userId);
            this.formData.append('sessionId', sessionId);
            // 注册的时候传给后端的phone号码也是会拼接区号的
            this.formData.append('mobileNumber', `${phone}`);
            this.formData.append('callPrefix', exphone);
            this.formData.append('lang', i18n.locale);
            // eslint-disable-next-line no-plusplus
            // const size = Math.floor(
            //   this.userUploadFile[0]?.size && this.userUploadFile[0]?.size / 1024,
            // );
            // if (size > 5 * 1024) {
            //   window.alert(this.$i18n.t('upload-limit'));
            //   return;
            // }
            // 更新用户信息 + 头像上传
            this.$http.member
              .updateUser(this.formData)
              .then(res => {
                if (res.state === '11') {
                  this.$messageModal.show({
                    image: true,
                    sucImgSrc: require('../LeftAccount/images/icon-verifyed.svg'),
                    closeIcon: false,
                    title: i18n.t('otp-verified-mobile-success'),
                    desc: i18n.t('profile-success'),
                    confirmBtn: i18n.t('ok'),
                    justHide: true,
                  });
                  this.getUserInfo();
                  this.getMFAStatus();
                } else if (res.state === '00') {
                  this.$messageModal.show({
                    image: false,
                    desc: res?.note,
                    i18nNeed: false,
                    closeIcon: true,
                    confirmBtn: 'ok',
                    justHide: true,
                    // callback: this.callbackFunc,
                  });
                }
              })
              .catch(err => {
                console.error(err);
              });

            this.errMessage = [];
            // 将showEditUserMsgModal放到微任务中，等上面的处理完后再执行
            this.$nextTick(() => {
              // 移动端因为是页面，所以不需要关闭整个弹窗
              if (!this.showDialog) {
                this.showEditUserMsgModal = true;
                return;
              }
              // PC端是组件，需要关闭整个弹窗
              this.showEditUserMsgModal = false;
            });
            if (this.showDialog) {
              this.showEditUserMsgModal = true;
              this.$emit('updateFather');
            }
          } else {
            this.errMessage = errMsg;
          }
        });
      },
      getUserInfo() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
        };

        this.$http.member
          .getUserInfo(data)
          .then(res => {
            if (res.state === '11') {
              sessionStorage.setItem('user', encryptAES(JSON.stringify(res.userInfo)));
              store.commit('setState', {
                state: 'userInfo',
                values: res.userInfo,
              });
              // this.showMessageBox('success');
              // PC端通知LeftAccount组件更新用户信息
              // this.$emit('updateSuc', this.userInfo)
              this.$emit('updateFather');
            } else {
              console.error(res.note);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      getMFAStatus() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          lang: i18n.locale,
          sessionId,
        };
        this.$http.account.getMFAStatus(data).then(res => {
          if (res.state === '11') {
            store.commit('setState', {
              state: 'mfaDetail',
              values: res.payload,
            });
          }
        });
      },
      handleUploadFile(data) {
        this.userUploadFile = data;
      },
      // 获取到组件内修改后返回的数据
      formValueChange(data) {
        const mobileNumber = `+${data.exphone}${data.phone}`;
        this.userEditFormValue = { ...this.userEditFormValue, ...data, mobileNumber };
      },
      handleOTP() {
        if (this.$route.path === '/profile') {
          this.sendAuthCode(() => {
            this.handleCaptchaShow(true);
          });
        } else {
          this.handleCancel();
          this.$emit('updateFather');
          // 将保存方法当作回调暴露出去，验证码通过后直接保存新的手机号
          this.$emit('handleOTP', this.userEditFormValue, this.handleSave);
        }
      },
      handleConfirm() {
        // 为了保证手机号输入框的onblur事件能够触发
        this.$nextTick(() => {
          const newPhone = this.userEditFormValue.exphone + this.userEditFormValue.phone;
          const { phoneEx: exphone, phone } = this.userInfo;
          const phEx = `+${exphone}`;
          const rightPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
          const oldPhone = exphone + rightPhone;
          if (newPhone === oldPhone) {
            // 手机号未修改直接保存
            this.handleSave();
          } else {
            // 只选择区号而不修改手机号,不触发校验,需要手动触发
            verify({
              mobileNumber: this.userEditFormValue.phone === '' ? '' : `+${newPhone}`,
              phone: this.userEditFormValue.phone,
            }).then(errMsg => {
              if (errMsg?.pass) {
                this.handleOTP();
              } else {
                this.errMessage = errMsg;
              }
            });
          }
        });
      },
      handleCaptchaShow(value) {
        this.showCaptcha = value;
        this.showEditUserMsgModal = !value;
      },
      sendAuthCode(successCallback) {
        const { callPrefix, phone, userId } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const data = {
          userId,
          authType: 2,
          callPrefix,
          phone,
          userContactToken,
          lang: this.$i18n.locale,
          sendScene: 1, // 0 默认普通opt场景    1 修改手机场景
        };
        this.$http.account.sendAuthCode(data).then(res => {
          if (res.state === '11') {
            // code sent
            this.authKey = res.payload.key;
            successCallback && successCallback();
          } else {
            // 错误码处理
            if (res.errorCode === 'retry.after.1.min') {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-4'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
              });
            } else if (res.errorCode === 'changePhone.error.6.locked.30') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-3'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-5'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.handleCaptchaShow(false);
                },
              });
            } else if (res.errorCode === 'changePhone.too.many.requests') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-2'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-2'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.handleCaptchaShow(false);
                },
              });
            }
          }
        });
      },
      handleResend(callback) {
        this.sendAuthCode(callback);
      },
      handleFinish(data) {
        console.log('finish', data);
        this.errCaptchaMsg = '';
      },
      handleDone(authCode) {
        console.log('done');
        const { callPrefix, phone, userId } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const data = {
          userId,
          lang: this.$i18n.locale,
          authType: 2,
          authCode,
          key: this.authKey,
          deviceId: localStorage.getItem('deviceId'),
          callPrefix,
          phone,
          userContactToken,
          checkScene: 1,
        };
        this.$http.account
          .checkAuthCode(data)
          .then(res => {
            if (res.state === '11') {
              // show success
              this.handleCaptchaShow(false);
              this.handleSave();
            } else {
              if (res.errorCode === 'opt.code.error') {
                this.errCaptchaMsg = this.$i18n.t('code-auth-notmatch');
              } else if (res.errorCode === 'changePhone.error.6.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-1'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.handleCaptchaShow(false);
                  },
                });
              } else if (res.errorCode === 'auth.error.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-3'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.handleCaptchaShow(false);
                  },
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index.scss';
  @use 'mobile.scss';
</style>
